


























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'SurveyConfirmModal' })
export default class SurveyConfirmModal extends Vue {
  @Prop({})
  surveyProduct!: string
}
